const chunkMapping = {
	"84": [
		4084
	],
	"371": [
		37371
	],
	"383": [
		68383
	],
	"417": [
		63417
	],
	"441": [
		10441
	],
	"531": [
		85531
	],
	"711": [
		34844
	],
	"998": [
		93998
	]
};
const idToExternalAndNameMapping = {
	"4084": [
		"default",
		"./Configuration",
		33859
	],
	"10441": [
		"default",
		"./Template",
		9858
	],
	"34844": [
		"default",
		"./RfpApp",
		5023
	],
	"37371": [
		"default",
		"./Category",
		9858
	],
	"63417": [
		"default",
		"./BmkStaticContentTranslation",
		9858
	],
	"68383": [
		"default",
		"./TarServices",
		33859
	],
	"85531": [
		"default",
		"./Translation",
		33859
	],
	"93998": [
		"default",
		"./BMKLanguageService",
		9858
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise && promise.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}